import { useState } from "react";
import { Button, Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";

const SearchButton = (props: any) => {
	const [searchState, setSearchState] = useState<any>(false);
	const [searchValue, setSearchValue] = useState<any>(null);

	const icon = props.icon || <SearchOutlined />;

	// Use controlled value from parent if provided, otherwise internal state
	const displayValue = props.value !== undefined ? props.value : searchValue;

	const handleSearch = (e: any) => {
		if (e.type == "change") {
			setSearchValue(e.target.value);
		} else {
			props.handleSearch({
				columnKey: props.columnKey,
				value: "",
			});
			setSearchValue(null);
			setSearchState(false);
		}
	};

	const handleSearchEnter = (e: any) => {
		props.handleSearch({
			columnKey: props.columnKey,
			value: e.target.value,
		});
		setSearchState(false);
	};

	return searchState ? (
		<Input
			className={
				props.searchBarType == "panel"
					? "input-clearable-panel"
					: "input-clearable"
			}
			onClick={(e) => {
				e.stopPropagation();
			}}
			onChange={handleSearch}
			onKeyDown={(e) => {
				e.stopPropagation();
			}}
			onBlur={handleSearchEnter}
			onPressEnter={handleSearchEnter}
			value={searchValue}
			allowClear
			autoFocus
			prefix={<SearchOutlined />}
			disabled={props.disabled}
		/>
	) : (
		<Button
			className="search-button"
			type={props.buttonType || "default"}
			onClick={(e) => {
				e.stopPropagation();
				setSearchState(true);
			}}
			style={{
				border: "none",
				boxShadow: "none",
				backgroundColor: "transparent",
			}}
			icon={icon}
		>
			{props.headerName}{" "}
			{displayValue != null && displayValue !== "" && `(${displayValue})`}
		</Button>
	);
};

export default SearchButton;
